import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WORK_ORDER_TASKS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('WORK_ORDER_TASKS');
export const WORK_ORDER_TASKS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WORK_ORDER_TASKS_CRUD_ACTION_CONSTANTS
);
